import request from 'services/axios';

export const userMessages = async (ctx: string, pageParam: number) => {
  const {data}: {data: UserMessagesProps} = await request.get(
    `/api/v2/chat/chats/${ctx}?page=${pageParam}`,
  );
  return data;
};

export const userSendrMessages = async (payload: IUserSendChatPayload) => {
  const {data} = await request.post(`/api/v2/chat/market-send-message`, {
    ...payload,
  });
  return data;
};

export const reportMSG = async (payload: IReportMSG) => {
  const {data} = await request.post(`/api/v2/chat/chat-report`, {
    ...payload,
  });
  return data;
};
